var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          d:
            "M11.912565,19.042455 C7.974615,19.042455 4.782315,15.850155 4.782315,11.912655 C4.782315,7.974705 7.974615,4.782405 11.912565,4.782405 C15.850065,4.782405 19.042365,7.974705 19.042365,11.912655 C19.042365,15.850155 15.850065,19.042455 11.912565,19.042455 L11.912565,19.042455 Z M11.912565,2.999955 C6.990465,2.999955 2.999865,6.990105 2.999865,11.912655 C2.999865,16.834755 6.990465,20.824905 11.912565,20.824905 C16.834665,20.824905 20.825265,16.834755 20.825265,11.912655 C20.825265,6.990105 16.834665,2.999955 11.912565,2.999955 L11.912565,2.999955 Z M16.35784,11.9127794 L10.35784,15.91243 L10.35784,7.91243 L16.35784,11.9127794 Z",
          id: "play"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#play"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }